<script lang="ts">
  import Loading from "../../assets/svg/Loading.svelte"

  export let cls: string = "flex p-1 pl-2"
</script>

<div class={cls}>
  <div class="h-6 w-6 min-w-6 shrink-0 animate-spin self-center">
    <Loading />
  </div>
  <div class="ml-2 w-full">
    <slot />
  </div>
</div>
